import React, { useRef, useEffect, useState } from "react";
import { Table } from "reactstrap";
import ReactTooltip from "react-tooltip";

import {
  HourToCanChi,
  nguHanh,
  ThapThan,
  ThanSatDiaChi,
  ThanSatThienCan,
  TangCan,
  HourToCanChi_,
} from "./convert";
import { handleCheckDungThan } from "./dungThanUtils";

const TableHour = ({
  year,
  month,
  day,
  thienCanNgay,
  dungThan,
  checkDungThan,
}) => {
  const [thangData, setThangData] = useState([]);
  const [tangCanThang, setTangCanThang] = useState([]);
  const [objectDaiVanData, setObjectDaiVan] = useState([]);

  // Lấy cài đặt dụng thần từ localStorage
  const profile = JSON.parse(localStorage.getItem("profile")) || {};
  const dungThanCaiDatThienCan = profile.dungThanCaiDatThienCan || [];
  const dungThanCaiDatDiaChi = profile.dungThanCaiDatDiaChi || [];

  const handleResult = async () => {
    const result = [];
    let months = month - 1;
    const tangCanThang = [];
    let objectDaivan = [];
    let currentYear = new Date().getFullYear();
    let hour_ = 1;

    for (let index = 1; index < 13; index++) {
      const tempTime = new Date(year, months, day, hour_);

      const dayShow = tempTime.getDate();
      const tempCanChiHour = HourToCanChi_(
        thienCanNgay,
        tempTime.getHours()
      )?.name?.split(" ");

      const diaChiHour = tempCanChiHour[1];

      const nguHanhTC = nguHanh(thienCanNgay,tempCanChiHour[0]);
      const thapThan = ThapThan(tempCanChiHour[0], thienCanNgay);
      const thanSatMonthArr = ThanSatDiaChi(tempCanChiHour[0], thienCanNgay);
      const thanSatMonthCan = ThanSatThienCan(tempCanChiHour[0], thienCanNgay);
      const TangCanMonthArr = TangCan(tempCanChiHour[1]);
      const thapThanMonth1 = ThapThan(
        tempCanChiHour[0],
        TangCanMonthArr[0]?.name
      );
      const thapThanMonth2 = ThapThan(
        tempCanChiHour[0],
        TangCanMonthArr[1]?.name
      );
      const thapThanMonth3 = ThapThan(
        tempCanChiHour[0],
        TangCanMonthArr[2]?.name
      );

      tangCanThang.push({
        TangCan: TangCanMonthArr,
        ThapThan1: thapThanMonth1,
        ThapThan2: thapThanMonth2,
        ThapThan3: thapThanMonth3,
        year,
        month: months + 1,
        date: dayShow,
        hour: tempTime.getHours(),
      });
      result.push({
        thienCan: tempCanChiHour[0],
        diaChi: diaChiHour,
        nguHanhTC,
        thapThan,
        thanSatMonthArr,
        thanSatMonthCan,
        month: months + 1,
        year,
        date: dayShow,
        hour: hour_,
      });
      hour_ += 2;
    }

    if (result[0]?.year <= currentYear && result[0]?.year > currentYear - 10) {
      objectDaivan = result[0];
    }
    tangCanThang.reverse();
    result.reverse();
    setThangData(result);
    setObjectDaiVan(objectDaivan);
    setTangCanThang(tangCanThang);
  };

  useEffect(() => {
    handleResult();
  }, [day]);

  return (
    <>
      <div style={{ pageBreakBefore: "always" }}></div>

      <div
        id="table_dv"
        style={{
          maxWidth: "1600px",
          margin: "0 auto",
          zIndex: "1000",
          position: "relative",
          overflowX: "scroll",
        }}
      >
        <Table
          hover
          bordered
          style={{
            textAlign: "center",
            marginTop: "35px",
          }}
        >
          <tbody>
            <tr className="fz__16">
              {thangData?.map((x) => {
                return (
                  <td
                    id={
                      objectDaiVanData.year === x.year && x.month === 1
                        ? "bg_hang1"
                        : ""
                    }
                    style={{ minWidth: "155px", cursor: "pointer" }}
                    className={
                      objectDaiVanData.year === x.year && x.month === 1
                        ? "border__1px background_"
                        : "border__1px"
                    }
                  >
                    Năm ({x.year}) <br /> Tháng ({x.month}) <br /> Ngày {x.date}{" "}
                    <br /> {x.hour} Giờ
                  </td>
                );
              })}

              <th
                id="bg__age"
                className="bg__ clr__white fz__15 fw__b"
                style={{ width: "58px" }}
              >
                Tháng
              </th>
            </tr>

            <tr style={{ textAlign: "center" }}>
              {thangData.map((x) => {
                // Logic tô màu Thiên Can (dòng trên - hiển thị chữ Thiên Can)
                const isDungThanThienCanRow = handleCheckDungThan(x.thienCan, dungThan, dungThanCaiDatThienCan, checkDungThan);

                return (
                  <td
                    id={
                      isDungThanThienCanRow
                        ? "dungThan"
                        : objectDaiVanData.year === x.year && x.month === 1
                        ? "bg_hang2"
                        : ""
                    }
                    style={{ fontWeight: "bold", cursor: "pointer" }}
                    className={
                      isDungThanThienCanRow
                        ? "fz__22 clr__ border__1px background"
                        : objectDaiVanData.year === x.year && x.month === 1
                        ? "fz__22 clr__ border__1px background_"
                        : "fz__22 clr__ border__1px"
                    }
                  >
                    <div data-for="con-giap" data-tip={x.thienCan}>
                      <sup className="fz__15" style={{ paddingRight: "4px" }}>
                        {x.thapThan?.sinhKhac}
                      </sup>
                      {x.thienCan}
                    </div>
                  </td>
                );
              })}

              <th
                id="bg__lnntc"
                rowSpan="2"
                className="bg__ clr__white fz__15 fw__b"
                data-for="thien-can"
                data-tip="Thiên Can"
              >
                Thiên Can
              </th>
            </tr>

            <tr style={{ textAlign: "center" }}>
              {thangData.map((x) => {
                // Dòng dưới của Thiên Can (hiển thị ngũ hành) - không tô màu
                return (
                  <th
                    style={{ fontWeight: "normal", cursor: "pointer" }}
                    colspan="1"
                    className={
                      objectDaiVanData.year === x.year && x.month === 1
                        ? "fz__15 border__1px background_"
                        : "fz__15 border__1px"
                    }
                    id={
                      objectDaiVanData.year === x.year && x.month === 1
                        ? "bg_hang3"
                        : ""
                    }
                  >
                    {x.nguHanhTC}
                  </th>
                );
              })}
            </tr>

            <tr>
              {thangData.map((x) => {
                // Logic tô màu Địa Chi
                const isDungThanDiaChi = handleCheckDungThan(x.diaChi, dungThan, dungThanCaiDatDiaChi, checkDungThan);

                return (
                  <td
                    id={
                      isDungThanDiaChi
                        ? "dungThan"
                        : objectDaiVanData.year === x.year && x.month === 1
                        ? "bg_hang4"
                        : ""
                    }
                    style={{ fontWeight: "bold", cursor: "pointer" }}
                    className={
                      isDungThanDiaChi
                        ? "fz__22 clr__ border__1px background"
                        : objectDaiVanData.year === x.year && x.month === 1
                        ? "fz__22 clr__ border__1px background_"
                        : "fz__22 clr__ border__1px"
                    }
                  >
                    {x.diaChi}
                  </td>
                );
              })}

              <th
                id="bg__lnndc"
                rowSpan="1"
                className="bg__ clr__white fz__15 fw__b"
                data-for="dia-chi"
                data-tip="Địa Chi"
              >
                Địa Chi
              </th>
            </tr>

            <tr className="fz__10">
              {tangCanThang?.map((val) => {
                // Tàng Can - không tô màu dụng thần
                return (
                  <td
                    style={{
                      verticalAlign: "middle",
                      padding: "0",
                      cursor: "pointer",
                    }}
                    className={
                      objectDaiVanData.year === val.year && val.month === 1
                        ? "border__1px background_"
                        : "border__1px"
                    }
                    id={
                      objectDaiVanData.year === val.year && val.month === 1
                        ? "bg_hang5"
                        : ""
                    }
                  >
                    {val.TangCan[1]?.name ? (
                      <td
                        style={{
                          border: "none",
                          padding: "0 10px 0 10px",
                        }}
                        id={
                          val?.year <= new Date().getFullYear() &&
                          val?.year > new Date().getFullYear() - 10
                            ? "none_bg"
                            : "none"
                        }
                      >
                        <div>
                          <sup>{val?.ThapThan2?.sinhKhac}</sup>

                          {val?.TangCan[1]?.name}
                        </div>
                        <div>
                          <div>{val?.TangCan[1]?.nguHanh}</div>
                        </div>
                      </td>
                    ) : (
                      ""
                    )}

                    {val?.TangCan[1]?.name && val?.TangCan[2]?.nguHanh ? (
                      <th
                        id={
                          val?.year <= new Date().getFullYear() &&
                          val?.year > new Date().getFullYear() - 10
                            ? "none3_bg"
                            : "none3"
                        }
                        style={{
                          borderLeft: "1px solid black",
                          borderRight: "1px solid black",
                          borderTop: "none",
                          borderBottom: "none",
                        }}
                      >
                        <div>
                          <sup>{val?.ThapThan1.sinhKhac}</sup>
                          {val?.TangCan[0]?.name}
                        </div>
                        <div>
                          <div>{val?.TangCan[0]?.nguHanh}</div>
                        </div>
                      </th>
                    ) : val?.TangCan[2]?.name ? (
                      <th
                        id={
                          val?.year <= new Date().getFullYear() &&
                          val?.year > new Date().getFullYear() - 10
                            ? "none_bg4"
                            : "none4"
                        }
                        style={{
                          borderLeft: "none",
                          borderRight: "1px solid black",
                          borderTop: "none",
                          borderBottom: "none",
                        }}
                      >
                        <div>
                          <sup>{val?.ThapThan1.sinhKhac}</sup>
                          {val?.TangCan[0]?.name}
                        </div>
                        <div>
                          <div>{val?.TangCan[0]?.nguHanh}</div>
                        </div>
                      </th>
                    ) : (
                      <th
                        id={
                          val?.year <= new Date().getFullYear() &&
                          val?.year > new Date().getFullYear() - 10
                            ? "none2_bg"
                            : "none2"
                        }
                        style={{
                          border: "none",
                          display: "inline-block",
                          margin: 0,
                        }}
                      >
                        <div>
                          <sup>{val?.ThapThan1.sinhKhac}</sup>
                          {val?.TangCan[0]?.name}
                        </div>
                        <div>
                          <div>{val?.TangCan[0]?.nguHanh}</div>
                        </div>
                      </th>
                    )}

                    {val?.TangCan[2]?.name && val?.TangCan[1]?.name ? (
                      <td
                        id={
                          val?.year <= new Date().getFullYear() &&
                          val?.year > new Date().getFullYear() - 10
                            ? "none2_bg"
                            : "none2"
                        }
                        style={{
                          border: "none",
                          padding: "0 5px",
                        }}
                      >
                        <div>
                          <sup>{val?.ThapThan3?.sinhKhac}</sup>

                          {val?.TangCan[2]?.name}
                        </div>
                        <div>
                          <div>{val?.TangCan[2]?.nguHanh}</div>
                        </div>
                      </td>
                    ) : (
                      <td
                        id={
                          val?.year <= new Date().getFullYear() &&
                          val?.year > new Date().getFullYear() - 10
                            ? "none2_bg"
                            : "none2"
                        }
                        style={{
                          border: "none",
                          padding: "0 15px",
                        }}
                      >
                        <div>
                          <sup>{val?.ThapThan3?.sinhKhac}</sup>

                          {val?.TangCan[2]?.name}
                        </div>
                        <div>
                          <div>{val?.TangCan[2]?.nguHanh}</div>
                        </div>
                      </td>
                    )}
                  </td>
                );
              })}

              <th id="bg__lnntcc" className="bg__ clr__white fz__15 fw__b">
                Tàng Can
              </th>
            </tr>
          </tbody>
        </Table>
      </div>
      <ReactTooltip
        id="con-giap"
        getContent={(dataTip) => (
          <div>
            <h5 style={{ textAlign: "center" }}>{dataTip}</h5>
            <p style={{ color: "blue" }}>
              Xin vui lòng{" "}
              <span
                className="click-span"
                onClick={() => {
                  if (dataTip === "Giáp") {
                    window.open(
                      "https://www.youtube.com/watch?v=N9E8dt6mtHc&t=31s"
                    );
                  } else if (dataTip === "Ất") {
                    window.open("https://www.youtube.com/watch?v=phqBCvqlLVk");
                  } else if (dataTip === "Bính") {
                    window.open("https://www.youtube.com/watch?v=MWg_sgJxcto");
                  } else if (dataTip === "Đinh") {
                    window.open("https://www.youtube.com/watch?v=-QB6i5bWwxE");
                  } else if (dataTip === "Mậu") {
                    window.open("https://www.youtube.com/watch?v=qs5jw6rGNBI");
                  } else if (dataTip === "Kỷ") {
                    window.open("https://www.youtube.com/watch?v=7Q3ivslkQk4");
                  } else if (dataTip === "Canh") {
                    window.open("https://www.youtube.com/watch?v=cNZGmL6mpAI");
                  } else if (dataTip === "Tân") {
                    window.open("https://www.youtube.com/watch?v=xR1EIu_J6oo");
                  } else if (dataTip === "Nhâm") {
                    window.open("https://www.youtube.com/watch?v=SUdNG6Zuoow");
                  } else if (dataTip === "Quý") {
                    window.open(
                      "https://www.youtube.com/watch?v=thOn-UpGob8&t=8s"
                    );
                  }
                }}
              >
                Click
              </span>{" "}
              vào đây để tìm hiểu thêm
            </p>
          </div>
        )}
        effect="solid"
        delayHide={500}
        delayShow={500}
        delayUpdate={500}
        place="top"
        border={true}
        type="light"
      />
      <ReactTooltip
        id="thien-can"
        getContent={(dataTip) => (
          <div>
            <h5 style={{ textAlign: "center" }}>{dataTip}</h5>
            <p style={{ color: "blue" }}>
              Xin vui lòng
              <span
                className="click-span"
                onClick={() => {
                  window.open(
                    "https://www.phongthuytuongminh.com/thien-can-dia-chi-la-gi-thien-can-dia-chi-co-y-nghia-quan-trong-nhu-the-nao.html"
                  );
                }}
              >
                {" "}
                Click{" "}
              </span>
              vào đây để tìm hiểu thêm
            </p>
          </div>
        )}
        effect="solid"
        delayHide={500}
        delayShow={500}
        delayUpdate={500}
        place="top"
        border={true}
        type="light"
      />
      <ReactTooltip
        id="dia-chi"
        getContent={(dataTip) => (
          <div>
            <h5 style={{ textAlign: "center" }}>{dataTip}</h5>
            <p style={{ color: "blue" }}>
              Xin vui lòng
              <span
                className="click-span"
                onClick={() => {
                  window.open(
                    "https://www.phongthuytuongminh.com/vi/thien-can-dia-chi-la-gi-thien-can-dia-chi-co-y-nghia-quan-trong-nhu-the-nao.html"
                  );
                }}
              >
                {" "}
                Click{" "}
              </span>
              vào đây để tìm hiểu thêm
            </p>
          </div>
        )}
        effect="solid"
        delayHide={500}
        delayShow={500}
        delayUpdate={500}
        place="top"
        border={true}
        type="light"
      />
    </>
  );
};

export default TableHour;
